import { FC } from 'react'
import PerButton from '../components/custom_components/Button'
import { useTranslation } from 'react-i18next'
import { PerEmpty } from '../components/custom_components/Empty'
import { useHistory } from 'react-router'

type ErrorComponentProps = {
  heading?: string
  info?: string
  info2?: string
  button?: boolean
}

const ErrorComponent: FC<ErrorComponentProps> = ({ heading, info, info2, button = false }) => {
  const [t] = useTranslation()
  const history = useHistory()

  return (
    <PerEmpty
      icon="smileyConcerned_stroke"
      iconColor="error"
      iconSize="xxl"
      heading={heading ? heading : t('page.error.pageUnavailable.title')}
      info={info ? info : t('page.error.pageUnavailable.info')}
      info2={info2}
      button={
        button && (
          <PerButton
            text={t('page.error.btnBack')}
            color="primary"
            variant="pastel"
            before="chevronLeft_stroke"
            onClick={() => history.goBack()}
          />
        )
      }
    />
  )
}

// ------
// ERRORS
// ------

export const ErrorMultipleUser = (): JSX.Element => {
  const [t] = useTranslation()
  return <ErrorComponent heading={t('page.error.meplyUnavailable.title')} info={t('page.error.multipleUsers.info')} />
}

export const ErrorUnknownUser = (): JSX.Element => {
  const [t] = useTranslation()
  return (
    <ErrorComponent
      heading={t('page.error.meplyUnavailable.title')}
      info={t('page.error.unknownUser.info')}
      info2={t('page.error.unknownUser.info2')}
    />
  )
}

export const ErrorNotFound = (): JSX.Element => {
  return (
    <div data-e2e-page-not-found>
      <ErrorComponent button />
    </div>
  )
}

export const ErrorPermissionDenied = (): JSX.Element => {
  return <ErrorComponent button />
}

export const ErrorNoData = (): JSX.Element => {
  return <ErrorComponent button />
}

export const ErrorQuery = (): JSX.Element => {
  return <ErrorComponent button />
}
